import { CartUpdateEvent } from '@theme/events';
let queue = Promise.resolve();
document.addEventListener('submit', (event) => {
  const form = event.target.closest('.ls-quick-add');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  if (button.disabled) return;
  const status = form.querySelector('[role="status"]');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  status.textContent = 'Adding…';
  queue = queue.then(async () => {
    let added = false;
    try {
      const response = await fetch(form.action + '.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
      added = true;
      const cartResponse = await fetch(form.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      document.dispatchEvent(new CartUpdateEvent(cart, 'ls-quick-add', {source:'ls-quick-add', itemCount:cart.item_count}));
      document.querySelectorAll('a.action__cart').forEach(link => link.setAttribute('aria-label', `Cart: ${cart.item_count} items`));
      status.textContent = 'Added to your cart.';
    } catch (error) {
      status.textContent = added ? 'Item added. Open your cart to check the updated total.' : (error.message || 'Unable to add item. Please try again.');
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
});
